import ArchiveIcon from '@mui/icons-material/Archive';
import AssignmentIcon from '@mui/icons-material/Assignment';
import AssignmentLateIcon from '@mui/icons-material/AssignmentLate';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import DescriptionIcon from '@mui/icons-material/Description';
import LayersIcon from '@mui/icons-material/Layers';
import ListAlt from '@mui/icons-material/ListAlt';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import type { KPICardDefinition } from 'ml-react-component-library';

import type {
  EngagementGridRow,
  LetterType,
  RelatedClientGridRow,
  WaiverGridRow,
} from '@/apps/engagement-letter-database/data/types';

type kpiData = {
  letterType: LetterType;
  isRelatedClientView: boolean;
  relatedClientRows: RelatedClientGridRow[];
  relatedClientTotalCount: number;
  sortedWaiverRows: WaiverGridRow[];
  sortedEngagementRows: EngagementGridRow[];
};

const buildKpiCards = (data: kpiData): KPICardDefinition[] => {
  if (data.letterType === 'engagement' && data.isRelatedClientView) {
    return [
      {
        label: 'Related Client Groups',
        value: data.relatedClientTotalCount,
        icon: <ListAlt color="primary" />,
        iconColor: 'primary.main',
        iconSize: 30,
      },
      {
        label: 'Linked Client Records',
        value: data.relatedClientRows.reduce((total, row) => total + row.clientCount, 0),
        icon: <PeopleAltIcon color="info" />,
        iconColor: 'info.main',
        iconSize: 30,
      },
      {
        label: 'Groups with Multiple Clients',
        value: data.relatedClientRows.filter((row) => row.clientCount > 1).length,
        icon: <LayersIcon color="secondary" />,
        iconColor: 'secondary.main',
        iconSize: 30,
      },
    ];
  }

  if (data.letterType === 'engagement') {
    return [
      {
        label: 'Total Records',
        value: data.sortedEngagementRows.length,
        icon: (
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <ListAlt color="primary" />
          </div>
        ),
        // iconBg: '#E0E0E0',
        iconColor: 'primary.main', //#424242
        iconSize: 30,
      },
      {
        label: 'Executed',
        value: data.sortedEngagementRows.filter((row) => row.isExecuted).length,
        icon: (
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <AssignmentTurnedInIcon color="success" />
          </div>
        ),
        iconColor: 'success.main', //#4caf50
        iconSize: 30,
      },
      {
        label: 'Not Executed',
        value: data.sortedEngagementRows.filter((row) => !row.isExecuted).length,
        icon: (
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <AssignmentLateIcon color="warning" />
          </div>
        ),
        iconColor: 'warning.main', //#ff9800
        iconSize: 30,
      },
      {
        label: 'Open',
        value: data.sortedEngagementRows.filter((row) => !row.closedDate).length,
        icon: (
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <AssignmentIcon color="info" />
          </div>
        ),
        iconColor: 'info.main', //#2196f3
        iconSize: 30,
      },
      {
        label: 'Closed',
        value: data.sortedEngagementRows.filter((row) => row.closedDate).length,
        icon: (
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <ArchiveIcon color="success" />
          </div>
        ),
        iconColor: 'success.main', //#4caf50
        iconSize: 30,
      },
    ];
  }
  if (data.letterType === 'waiver') {
    return [
      {
        label: 'Total Records',
        value: data.sortedWaiverRows.length,
        icon: (
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <ListAlt color="primary" />
          </div>
        ),
        // iconBg: '#E0E0E0',
        iconColor: 'primary.main', //#424242
      },
      {
        label: 'Multiple Waivers',
        value: data.sortedWaiverRows.filter((row) => row.multipleWaivers === 'Yes').length,
        icon: (
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <LayersIcon color="secondary" />
          </div>
        ),
        iconColor: 'secondary.main', //#f50057
        iconSize: 30,
      },
      {
        label: 'Single Waiver',
        value: data.sortedWaiverRows.filter((row) => row.multipleWaivers === 'No').length,
        icon: (
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <DescriptionIcon color="info" />
          </div>
        ),
        iconColor: 'info.main', //#2196f3
        iconSize: 30,
      },
    ];
  }
  return [];
};

export default buildKpiCards;
